export default {
  UPDATE_DATA_FROM_API: 'updateDataFromAPI',
  UPDATE_TEXT_FROM_API: 'updateTextFromAPI',
  UPDATE_DATA_TO_API: 'updateDataToAPI',
  UPDATE_TEXT_TO_API: 'updateTextToAPI',
  UPDATE_URL_API: 'updateUrlAPI',
  UPDATE_APP_SETTINGS_FROM_API: 'updateAppSettingsFromApi',
  UPDATE_APP_SETTINGS_TO_API: 'updateAppSettingsToApi',
  UPDATE_APP_SETTINGS_ID: 'updateAppSettingsId',
  UPDATE_APP_SETTINGS_NAME: 'updateAppSettingsName',
  UPDATE_APP_SETTINGS_LOGO_URL: 'updateAppSettingsLogoUrl',
  UPDATE_APP_SETTINGS_DOCUMENT_LIST: 'updateAppSettingsDocumentList', //
  UPDATE_APP_SETTINGS_DOCUMENT_LIST_ADD_LANGUAGE: 'updateAppSettingsDocumentListAddLanguage', //
  UPDATE_APP_SETTINGS_COLORS: 'updateAppSettingscColors',
  UPDATE_APP_SETTINGS_FONT: 'updateAppSettingscFont',
  SAVE_APP_SETTINGS_LOGO: 'saveAppSettingsLogo',
  SAVE_APP_SETTINGS_COLORS: 'saveAppSettingsColors',
  SAVE_APP_SETTINGS_FONT: 'saveAppSettingsFont'
}
